// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
const { ago } = require('shared/date')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const { eventHandler } = require('client-v2/common/utils/events')
const UserAvatar = require('client-v2/common/components/user-avatar')
const { userProfileHref } = require('client-v2/common/models/user/actions')

// BEM Block entity definition
const bem = BemEntity('ArticleProfileCommentsItemV2')

function ArticleProfileCommentsItem(props) {

  const { comment } = props
  return (
    tag('li', {
      className: classNames(
        props.className,
        bem.block()
      )
    },
      tag(CommentUserAvatar, props),

      tag('div', {
        className: bem.element('content')
      },
        tag('div', {
          className: bem.element('header')
        },
          tag(CommentUsername, props),
          tag(CommentTimestamp, props),
          tag(CommentReportButton, props),
          tag(CommentDeleteButton, props)
        ),

        tag('div', {
          className: bem.element('text'),
          dangerouslySetInnerHTML: { __html: comment.text }
        })
      )
    )
  )
}

ArticleProfileCommentsItem.propTypes = {
  // Values
  article: PropTypes.object.isRequired,
  className: PropTypes.string,
  comment: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  // Callbacks
  onDeleteClick: PropTypes.func,
  onReportClick: PropTypes.func,
  onUserClick: PropTypes.func
}

module.exports = ArticleProfileCommentsItem

// BEM Block entity Element components

function CommentUserAvatar(props) {
  const { comment } = props
  return (
    tag(UserAvatar, {
      className: bem.element('user-icon'),
      href: true,
      user: props.comment,
      onClick: eventHandler(props.onUserClick, { user: comment })
    })
  )
}

function CommentUsername(props) {
  const { comment } = props
  return (
    tag('a', {
      className: classNames(
        bem.element('header-item'),
        bem.element('username')
      ),
      href: userProfileHref(comment),
      onClick: eventHandler(props.onUserClick, { user: comment })
    },
      `@${comment.username}`
    )
  )
}

function CommentTimestamp(props) {
  const { comment } = props
  const createdAt = new Date(comment['created_at'])
  return (
    tag('time', {
      className: classNames(
        bem.element('header-item'),
        bem.element('time')
      ),
      dateTime: createdAt.toISOString()
    },
      ago(createdAt)
    )
  )
}

function CommentReportButton(props) {
  const { article, comment, user } = props
  if (!user.loggedIn || comment['user_id'] === user.id) {
    return null
  }
  return (
    tag('button', {
      className: classNames(
        bem.element('header-item'),
        bem.element('button', 'report')
      ),
      title: 'Report this comment',
      onClick: () => props.onReportClick({ article, comment })
    })
  )
}

function CommentDeleteButton(props) {
  const { article, comment, user } = props
  if (!user.loggedIn || comment['user_id'] !== user.id) {
    return null
  }
  return (
    tag('button', {
      className: classNames(
        bem.element('header-item'),
        bem.element('button', 'delete')
      ),
      title: 'Delete this comment',
      onClick: () => props.onDeleteClick({ article, comment })
    })
  )
}
